import { Button, Dialog, DialogActions, Stack, Typography } from '@mui/material';
import { CancelToken } from 'apisauce';
import React, { useEffect, useState } from 'react';
import ModalHeader from '../../../../components/ModalHeader';
import { useTheme } from '@emotion/react';
import moment from 'moment';
import ShipIcon from '../../../../assets/images/ship.svg';
import DoneIcon from '@mui/icons-material/Done';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import NoDataFound from '../../../../components/NoDataFound/NoDataFound';
import appapi from '../../../../api/apiClient';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

export default function ReportDetails({ modelOpen, onModelHandleClose, data, voyageId, reportDetails }) {
  let source = CancelToken.source();
  const theme = useTheme();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const [voyageDetails, setVoyageDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const {t} = useTranslation()

  const handleDownload = async (data) => {
    try {
      const response = await fetch(data);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const name = data?.split('/').pop();
      link.download = `${name}`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  const getVoyageDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `fleet/voyage/${voyageId}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setVoyageDetails(data.response);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (voyageId) {
      getVoyageDetails();
    } else {
      setVoyageDetails(null);
    }
  }, [voyageId]);

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <ModalHeader
          label={t('Report details')}
          onClose={() => onModelHandleClose(false)}
        />
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />

        {/* {voyageDetails?.length <= 0 && !loading && <NoDataFound />} */}
        {loading && (
          <Stack
            flex={1}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <ActivityIndicator />
          </Stack>
        )}

        {!loading && (
          <>
            <Stack
              direction={'row'}
              className="!my-[16px]"
            >
              <Stack
                flex={0.5}
                className="px-[16px]"
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular"
                  color={text}
                >
                  {t('Report ID')}
                </Typography>
                <Typography
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  style={{ maxWidth: '225px' }}
                >
                  {reportDetails?.reportId || '-'}
                </Typography>
              </Stack>
              <Stack
                flex={0.5}
                className="px-[16px]"
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular"
                  color={text}
                >
                  {t('Verifier')}
                </Typography>
                <Typography
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  style={{ maxWidth: '225px' }}
                >
                  {reportDetails?.verifierName|| '-'}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              flex={0.5}
              className="px-[16px]"
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular"
                  color={text}
                >
                  {t('Voyage ID')}
                </Typography>
                {voyageDetails?.isVerified && (
                  <Stack
                    style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#00A632' }}
                    className="h-[12px] w-[12px] rounded-[6px] ml-[10px] "
                  >
                    <DoneIcon style={{ color: '#ffffff', transform: 'scale(0.5)' }} />
                  </Stack>
                )}
              </Stack>

              <Typography
                className="fs-14 ff-Roboto fw-medium"
                color={text}
                style={{ maxWidth: '225px', marginBottom:'16px' }}
              >
                {voyageDetails?.voyageId || '-'}
              </Typography>
            </Stack>
            <Stack
              direction={'row'}
              className="px-[16px] !mb-[16px]"
              alignItems={'center'}
            >
              <Stack flex={0.3}>
                <Typography
                  className="fs-12 ff-Roboto fw-regular !capitalize"
                  color={text}
                >
                  {t('Voyage from')}
                </Typography>
                <Stack className="mt-[12px]">
                  <Typography
                    className="fs-14 ff-Roboto fw-medium"
                    color={text}
                    style={{ maxWidth: '225px' }}
                    textTransform={'capitalize'}
                  >
                    {voyageDetails?.voyageFrom || '-'}
                  </Typography>
                  <Typography
                    className="fs-12 ff-Roboto fw-medium"
                    color={text}
                    style={{ maxWidth: '225px' }}
                  >
                    {moment(voyageDetails?.fromDate).format('DD-MMM-YYYY')}
                  </Typography>
                </Stack>
              </Stack>
              <Stack flex={0.3}>
                <img
                  src={ShipIcon}
                  style={{ width: '98px', height: '32px' }}
                />
              </Stack>
              <Stack flex={0.3}>
                <Typography
                  className="fs-12 ff-Roboto fw-regular !capitalize"
                  color={text}
                >
                  {t('Voyage to')}
                </Typography>
                <Stack className="mt-[12px]">
                  <Typography
                    className="fs-14 ff-Roboto fw-medium"
                    color={text}
                    style={{ maxWidth: '225px' }}
                    textTransform={'capitalize'}
                  >
                    {voyageDetails?.voyageTo || '-'}
                  </Typography>
                  <Typography
                    className="fs-12 ff-Roboto fw-medium"
                    color={text}
                    style={{ maxWidth: '225px' }}
                  >
                    {moment(voyageDetails?.toDate).format('DD-MMM-YYYY')}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              style={{ backgroundColor: '#14285A1A', width: '100%', height: '1px' }}
              className="!my-[16px] !mr-[16px]"
            />
            <Stack
              direction={'row'}
              className="!my-[16px]"
            >
              <Stack
                flex={0.5}
                className="px-[16px]"
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular !capitalize"
                  color={text}
                >
                  {t('Ship name')}
                </Typography>
                <Typography
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  style={{ maxWidth: '225px' }}
                >
                  {data?.shipName || '-'}
                </Typography>
              </Stack>
              <Stack
                flex={0.5}
                className="px-[16px]"
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular"
                  color={text}
                >
                  {t('Ship type')}
                </Typography>
                <Typography
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  style={{ maxWidth: '225px' }}
                >
                  {data?.shipType || '-'}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction={'row'}
              className="!my-[16px]"
            >
              <Stack
                flex={0.5}
                className="px-[16px]"
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular !capitalize"
                  color={text}
                >
                  {t('IMO no')}
                </Typography>
                <Typography
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  style={{ maxWidth: '225px' }}
                >
                  {data?.imoNumber || '-'}
                </Typography>
              </Stack>
              <Stack
                flex={0.5}
                className="px-[16px]"
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular !capitalize"
                  color={text}
                >
                  {t('Summer deadweight')}
                </Typography>
                <Typography
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  style={{ maxWidth: '225px' }}
                >
                  {data?.summerDeadWeight?.toLocaleString() || '-'}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              style={{ backgroundColor: '#14285A1A', width: '100%', height: '1px' }}
              className="!my-[16px] !mr-[16px]"
            />
            <Stack
              direction={'row'}
              className="!my-[16px]"
            >
              <Stack
                flex={0.5}
                className="px-[16px]"
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular"
                  color={text}
                >
                  {t('Fuel type')}
                </Typography>
                <Typography
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  style={{ maxWidth: '225px' }}
                >
                  {voyageDetails?.fuelUsed && voyageDetails?.fuelUsed[0]?.fuelType || '-'}
                </Typography>
              </Stack>
              <Stack
                flex={0.5}
                className="px-[16px]"
              >
                <Typography
                  className="fs-12 ff-Roboto fw-regular"
                  color={text}
                >
                  {t('Emission factor')}
                </Typography>
                <Typography
                  className="fs-14 ff-Roboto fw-medium"
                  color={text}
                  style={{ maxWidth: '225px' }}
                >
                  {voyageDetails?.fuelUsed && voyageDetails?.fuelUsed[0]?.emissionFactor || '-'}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              style={{ backgroundColor: '#14285A1A', width: '100%', height: '1px' }}
              className="!my-[16px] !mr-[16px]"
            />
            {/* <Stack
              direction={'row'}
              alignItems={'center'}
              className="px-[16px]"
            >
              <Stack flex={0.2}>
                <Typography className="fs-12 ff-Roboto fw-medium">Date</Typography>
                <Typography className="fs-14 ff-Roboto fw-regular">ccc</Typography>
              </Stack>
              <Stack flex={0.2}>
                <Typography className="fs-12 ff-Roboto fw-medium">Commenter</Typography>
                <Typography className="fs-14 ff-Roboto fw-regular">ccc</Typography>
              </Stack>
              <Stack flex={0.6}>
                <Typography className="fs-12 ff-Roboto fw-medium">Remark</Typography>
                <Typography className="fs-14 ff-Roboto fw-regular">ccc</Typography>
              </Stack>
            </Stack> */}
            <Stack flexGrow={1}></Stack>
            <DialogActions
              className="!mt-[94px] h-[66px] !justify-end p-[0px] sticky bottom-[0]"
              style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
            >
              <Button
                sx={[
                  dialogButtonCancel,
                  {
                    color: theme.palette.primary.main,
                    '&:hover': {
                      // backgroundColor: theme.palette.secondary.main,
                      // color: theme.palette.background.main,
                      // borderColor: theme.palette.secondary.main,
                    },
                  },
                ]}
                style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                onClick={() => {
                  onModelHandleClose(false);
                }}
              >
                {t('Close')}
              </Button>
              {voyageDetails?.voyageVerificationReport &&    <Button
                sx={[
                  dialogButtonCancel,
                  {
                    color: theme.palette.primary.main,
                    textTransform: 'uppercase',
                    '&:hover': {
                      // backgroundColor: theme.palette.secondary.main,
                      // color: theme.palette.background.main,
                      // borderColor: theme.palette.secondary.main,
                    },
                  },
                ]}
                style={{ width: '168px', marginLeft: '80px', height: '40px' }}
                onClick={() => handleDownload(voyageDetails?.voyageVerificationReport)}
              >
                {t('Download report')}
              </Button>}
            
            </DialogActions>
          </>
        )}
      </Stack>
    </Dialog>
  );
}
